import * as ng from 'angular';

import { reportViewerApp } from './report-viewer-module';

export const loadReportViewerAngularJsAppShell = (): ng.IModule => reportViewerApp;
